import { registerNotificationCallback, getNotifications } from '@services/notifications/NotificationTaskService'
import { store } from '@atredux/store'
import { getEffectiveStoreId } from '@atredux/selectors/storeSelector'
import { setNotificationCount } from '@atredux/slices/notificationSlice'

const updateNotificationCount = () => {
    const state = store.getState()
    const effectiveStoreId = getEffectiveStoreId(state)

    if (!effectiveStoreId) {
        store.dispatch(setNotificationCount(0))
        return
    }

    const notifications = getNotifications()
    const count = notifications ? notifications.length : 0

    store.dispatch(setNotificationCount(count))
}

export const initNotificationCount = () => {
    registerNotificationCallback(() => {
        updateNotificationCount()
    })
}
